import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { Button, message, Checkbox } from 'antd';
import MuiIconButton from 'material-ui/IconButton';
import MuiButton from 'material-ui/Button';
import DeleteIcon from '@material-ui/icons/Delete';
import localForage from 'localforage';

import BizCard from '../../components/UI/BizCard';
import BizInput from '../../components/UI/BizInput';
import FormFloatingButtons from '../../components/FormFloatingButtons';

import MUTATION from '../../graphql/mutations/lcsFisRequestMutation.graphql';

const DeleteFormRowButton = (props) => (
  <MuiIconButton
    aria-label="Delete"
    onClick={props.onClick}
    style={{ width: 30, height: 30 }}
  >
    <DeleteIcon />
  </MuiIconButton>
);
DeleteFormRowButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

const localForageItemkey = (cid) => (`${cid}_lcsFisRequest`);

const initialState = () => ({
  queries: [],
  docs: [],
  startedAt: new Date().toISOString(),
});

class LcsFisRequest extends Component {
  state = {
    ...initialState(),
  };

  componentDidMount() {
    localForage.getItem(localForageItemkey(this.props.match.params.cid))
      .then((value) => {
        if (value) {
          this.setState({
            ...value,
          });
        }
      });
  }

  clearForm = () => {
    localForage.removeItem(localForageItemkey(this.props.match.params.cid));
    this.setState({
      ...initialState(),
    });
  };

  saveData = () => {
    const { ...data } = this.state;
    localForage.setItem(localForageItemkey(this.props.match.params.cid), data)
      .then(() => {
        message.success('Saved!');
      })
      .catch(() => {
        message.error('Not Saved!');
      });
  };

  handleArrayFormValue = (arrayName, id, key, value) => {
    this.setState({
      [arrayName]: this.state[arrayName].map((entry) => {
        if (entry.id === id) {
          return { ...entry, [key]: value };
        }
        return entry;
      }),
    });
  };

  removeFormRow = (stateObjKey, id) => {
    this.setState({
      [stateObjKey]: this.state[stateObjKey].filter((entry) => (entry.id !== id)),
    });
  };

  handleFormSubmit = () => {
    const customerId = this.props.match.params.cid;

    this.props.mutate({
      variables: {
        customerId,
        ...this.state,
      },
    })
      .then(() => {
        message.success('Success!');
        this.clearForm();
        this.props.history.push(`/app/lead/${customerId}/lcs/fis`);
      })
      .catch((mutateErr) => {
        message.error(mutateErr.message);
      });
  };

  render() {
    const {
      queries,
      docs,
    } = this.state;

    return (
      <BizCard title="Further Information Request Sheet">
        <FormFloatingButtons handleSave={this.saveData} handleClear={this.clearForm} />
        <table className="biz-form-table">
          <tbody>
            {/* Queries */}
            <tr>
              <td className="biz-form-table-label">Queries</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table">
                  <thead>
                    <tr>
                      <th>Query</th>
                      <th>Send to Client</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {
                      queries.map((entry) => (
                        <tr key={entry.id}>
                          <td style={{ width: 320 }}>
                            <BizInput
                              type="textarea"
                              name={`queries[${entry.id}]`}
                              theme="lac"
                              onChange={(value) => { this.handleArrayFormValue('queries', entry.id, 'query', value); }}
                              value={entry.query}
                            />
                          </td>
                          <td>
                            <Checkbox
                              checked={entry.forClient}
                              onChange={(e) => { this.handleArrayFormValue('queries', entry.id, 'forClient', e.target.checked); }}
                            />
                          </td>
                          <td>
                            <DeleteFormRowButton onClick={() => { this.removeFormRow('queries', entry.id); }} />
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </td>
              <td className="biz-form-table-action">
                <Button
                  onClick={() => {
                    this.setState({
                      queries: [...queries, {
                        id: (+new Date()).toString(36),
                        query: '',
                        forClient: false,
                      }],
                    });
                  }}
                >
                  Add new query
                </Button>
              </td>
            </tr>

            {/* Documents */}
            <tr>
              <td className="biz-form-table-label">Documents request</td>
              <td className="biz-form-table-input">
                <table className="biz-data-table">
                  <thead>
                    <tr>
                      <th>Title</th>
                      <th>Description</th>
                      <th />
                    </tr>
                  </thead>
                  <tbody>
                    {
                      docs.map((entry) => (
                        <tr key={entry.id}>
                          <td>
                            <BizInput
                              name={`docs[${entry.id}][title]`}
                              theme="lac"
                              onChange={(value) => { this.handleArrayFormValue('docs', entry.id, 'title', value); }}
                              value={entry.title}
                            />
                          </td>
                          <td>
                            <BizInput
                              type="textarea"
                              name={`docs[${entry.id}][description]`}
                              theme="lac"
                              onChange={(value) => { this.handleArrayFormValue('docs', entry.id, 'description', value); }}
                              value={entry.description}
                            />
                          </td>
                          <td>
                            <DeleteFormRowButton onClick={() => { this.removeFormRow('docs', entry.id); }} />
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </table>
              </td>
              <td className="biz-form-table-action">
                <Button
                  onClick={() => {
                    this.setState({
                      docs: [...docs, {
                        id: (+new Date()).toString(36),
                        title: '',
                        description: '',
                      }],
                    });
                  }}
                >
                  Add new doc
                </Button>
              </td>
            </tr>

            <tr>
              <td className="biz-form-table-label" />
              <td colSpan={2}>
                <MuiButton variant="raised" color="primary" style={{ margin: '5px 0' }} onClick={this.handleFormSubmit}>
                  Submit
                </MuiButton>
              </td>
            </tr>
          </tbody>
        </table>
      </BizCard>
    );
  }
}

LcsFisRequest.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      cid: PropTypes.string.isRequired,
    }),
  }).isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  mutate: PropTypes.func.isRequired,
};

export default graphql(MUTATION)(LcsFisRequest);



// WEBPACK FOOTER //
// ./src/pages/leads/LcsFisRequest.jsx